import { render, staticRenderFns } from "./PreviewFullScreen.vue?vue&type=template&id=ac1ac49a"
import script from "./PreviewFullScreen.vue?vue&type=script&lang=js"
export * from "./PreviewFullScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac1ac49a')) {
      api.createRecord('ac1ac49a', component.options)
    } else {
      api.reload('ac1ac49a', component.options)
    }
    module.hot.accept("./PreviewFullScreen.vue?vue&type=template&id=ac1ac49a", function () {
      api.rerender('ac1ac49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/PreviewFullScreen.vue"
export default component.exports